import {
  SYNC_URL_COMPLETE,
  UPDATE_UI_PARAM,
  RESET_UI_PARAMS
} from '../constants';
import { urlSchema } from '../schema';
import { parseUrlToState } from '../utils';

// Generate default values from schema
const defaultSchemaParams = Object.keys(urlSchema).reduce((acc, key) => {
  acc[key] = urlSchema[key].defaultValue;
  return acc;
}, {});

// Synchronously read initial state from Window
const getInitialUrlData = () => {
  if (typeof window === 'undefined') {
    return {
      params: defaultSchemaParams,
      meta: { queryString: '', lang: 'en', pathName: '' }
    };
  }

  const parsedParams = parseUrlToState(window.location.search);

  return {
    params: { ...defaultSchemaParams, ...parsedParams },
    meta: {
      queryString: window.location.search,
    }
  };
};

// Initialize state immediately
const initialData = getInitialUrlData();

const initialState = {
  queryString: initialData.meta.queryString,
  parameters: initialData.params || {},
  uiParams: initialData.params || {},
};

export const urlReducer = (state = initialState, action) => {
  switch (action.type) {
    case SYNC_URL_COMPLETE:
      return {
        ...state,
        queryString: action.payload.queryString,
        parameters: action.payload.parameters,
        // uiParams: action.payload.parameters,
      };

    case UPDATE_UI_PARAM:
      return {
        ...state,
        uiParams: {
          ...state.uiParams,
          ...action.payload,
        },
      };

    case RESET_UI_PARAMS:
      return {
        ...state,
        uiParams: { ...state.parameters },
      };

    default:
      return state;
  }
};
